import { darken } from 'polished';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: ${props => darken(0.03, props.theme.Layout?.bodyBg ?? props.theme.colorBgLayout)};
  border-radius: 6px;
  color: ${props => props.theme.colorPrimary};
  font-size: 20px;
`;

export interface IIconBadgeProps {
  icon: React.ReactNode;
}

export function IconBadge(props: Readonly<IIconBadgeProps>) {
  return <Wrapper aria-hidden="true">{props.icon}</Wrapper>;
}
